import { toUsStateCode } from "../../utils/usStates.mjs";

// src/models/consultation/clinicalBookingStates.ts
/** Union of licensed state codes from {@link CONSULTANT_LICENSED_STATES_CACHE_DOC_ID}. */
function clinicalBookingSupportedStateCodes(userLicensedStateCodes) {
	const codes = /* @__PURE__ */ new Set();
	for (const states of Object.values(userLicensedStateCodes)) for (const state of states) {
		const normalized = toUsStateCode(state);
		if (normalized) codes.add(normalized);
	}
	return [...codes].sort();
}
function isClinicalBookingStateSupported(state, supportedStateCodes) {
	const normalized = toUsStateCode(state);
	if (!normalized) return false;
	return supportedStateCodes.includes(normalized);
}
/** Soft TTL for draft clinical bookings (24h). */
const CLINICAL_BOOKING_DRAFT_TTL_MS = 864e5;

export { CLINICAL_BOOKING_DRAFT_TTL_MS, clinicalBookingSupportedStateCodes, isClinicalBookingStateSupported };
//# sourceMappingURL=clinicalBookingStates.mjs.map